import { formatLedgerMoney } from '@/lib/api/accounts'

const PAYMENT_LABELS = {
  cash: 'Cash',
  card: 'Card',
  transfer: 'Transfer',
  apple_pay: 'Apple Pay',
}

/**
 * @param {string} code
 */
export function formatPaymentMixLabel(code) {
  return PAYMENT_LABELS[code] ?? code.replace(/_/g, ' ')
}

/**
 * @param {string | null | undefined} iso
 */
export function formatZReportDateTime(iso) {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return '—'
  return date.toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * @param {Record<string, number | string> | null | undefined} paymentMix
 * @returns {Array<{ code: string, label: string, amount: string }>}
 */
export function normalizePaymentMix(paymentMix) {
  if (!paymentMix || typeof paymentMix !== 'object') return []

  return Object.entries(paymentMix)
    .map(([code, amount]) => ({
      code,
      label: formatPaymentMixLabel(code),
      amount: formatLedgerMoney(amount),
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

/**
 * @param {HTMLElement | null | undefined} node
 */
export function printZReport(node) {
  if (!node) return

  document.body.classList.add('printing-thermal')
  window.print()
  window.addEventListener('afterprint', () => {
    document.body.classList.remove('printing-thermal')
  }, { once: true })
}
